import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createSurvey({ commit }, data) {
      try {
        return await api.post(`/params/surveys`, data)
      } catch (error) {
        throw error
      }
    },

    async getSurveys({ commit }) {
      try {
        const response = await api.get(`/params/surveys`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getSurveysActives({ commit }) {
      try {
        const response = await api.get(`/params/surveys?status=true`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getSurvey({ commit }, id) {
      try {
        const response = await api.get(`/params/surveys/${id}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateSurvey({ commit }, data) {
      try {
        return await api.put(`/params/surveys/${data.id}`, data.survey)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
